function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}

export { getHTMLElementScroll as g };
//# sourceMappingURL=getHTMLElementScroll-0a1d760c.js.map
